import SubscriberInput from "./SubscriberInput";
import { ClientWorkflow, defaultRecipient } from "@avenueops/shared-types";
import { Button } from "@avenueops/web-components";
import { useFieldArray } from "react-hook-form";

export interface Props {
  prefix?: string;
  deleteLevel: () => void;
  register: any;
  watch: any;
  levelIndex: number;
  control: any;
  isLast: boolean;
  setError: any;
  errors: any;
  clearErrors: any;
  manualOnly?: boolean;
  disableCustomize?: boolean;
  workflow?: ClientWorkflow;
}

export default function NotificationLevel({
  prefix = "notificationLevels",
  deleteLevel,
  levelIndex,
  control,
  isLast,
  manualOnly,
  disableCustomize,
  workflow,
}: Props) {
  const levelName = `${prefix}.${levelIndex}.recipients`;
  const { fields, append, remove } = useFieldArray({
    control,
    name: levelName,
  });

  const notificationFields = (
    <>
      {fields.length > 0 ? (
        fields.map((item, index) => (
          <SubscriberInput
            prefix={levelName}
            key={item.id}
            remove={remove}
            index={index}
            manualOnly={manualOnly}
            disableCustomize={disableCustomize}
            workflow={workflow}
          />
        ))
      ) : (
        <div className="text-sm font-medium text-gray-900 flex flex-row items-center py-2">There are currently no subscribers in this escalation group</div>
      )}
      <div className="flex flex-row gap-4">
        <Button type="SECONDARY" onClick={() => append(defaultRecipient)}>
          + Add {fields.length > 0 ? "Another" : "a"} Subscriber
        </Button>
      </div>
    </>
  );

  return levelIndex === 0 && isLast ? (
    <div>
      <div className="flex flex-col rounded-lg space-y-4">{notificationFields}</div>
    </div>
  ) : (
    <>
      <div className="flex flex-col space-y-4 border rounded-t p-4">
        <div className={"flex w-full flex-row font-medium justify-between"}>
          <p className="mt-1 leading-5 text-gray-800 text-sm">
            {levelIndex === 0
              ? "The first group to be notified"
              : levelIndex === 1
              ? "Will be notified if alert is escalated once"
              : `Will be notified if alert is escalated ${levelIndex} times`}
          </p>

          {levelIndex > 0 && (
            <div>
              <Button type="DANGER_SECONDARY" onClick={deleteLevel}>
                Remove Escalation Group
              </Button>
            </div>
          )}
        </div>
        <div className="bg-gray-50 rounded-lg p-10">{notificationFields}</div>
      </div>
    </>
  );
}
